import React from 'react';
import PropTypes from "prop-types";
import Fade from "@mui/material/Fade";

const RecordTotalsBar = (props) => {

    if (props.disabled) {
        return <div style={{display: 'inlineBlock', height: '34px'}}></div>;
    }
    return (
        <Fade in={true}>
            <div className="table-totals-bar grid-x grid-margin-x hide-for-small-only">
                <div className="cell small-12 medium-6">
                    <div className="totals-group">
                        {(props.leftItems).map((item, index) => (
                            <div className="totals-item" key={index}>
                                <div className={`total-label ${(index === 0) ? 'font-bold' : ''}`}>
                                    {item.label}
                                </div>
                                <div className="total-value badge square secondary">
                                    {item.value ?? '...'}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="cell small-12 medium-6">
                    <div className="totals-group align-right">
                        {(props.rightItems).map((item, index) => (
                            <div className="totals-item" key={index}>
                                <div className={`total-label ${(index === 0) ? 'font-bold' : ''}`}>
                                    {item.label}
                                </div>
                                <div className="total-value badge square secondary">
                                    {item.value ?? '...'}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Fade>
    );
};

RecordTotalsBar.propTypes = {
    leftItems: PropTypes.array,
    rightItems: PropTypes.array,
    disabled: PropTypes.bool,
};

RecordTotalsBar.defaultProps = {
    disabled: false,
};

export default RecordTotalsBar;
